import AppLayout from "Layout/Layout";
import { NonIndexRouteObject } from "react-router";
import { getResourcePath } from "./constant";
import { ListPage } from "pages/bao-cao/list-page";
import { DetailPage } from "pages/bao-cao/detail-page";
import { EditPage } from "pages/bao-cao/edit-page";
import { CreatePage } from "pages/bao-cao/create-page";

export const baoCaoRouters: NonIndexRouteObject[] = [
  {
    path: getResourcePath("bao-cao", "list"),
    element: (
      <AppLayout>
        <ListPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("bao-cao", "detail"),
    element: (
      <AppLayout>
        <DetailPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("bao-cao", "edit"),
    element: (
      <AppLayout>
        <EditPage />
      </AppLayout>
    ),
  },
  {
    path: getResourcePath("bao-cao", "create"),
    element: (
      <AppLayout>
        <CreatePage />
      </AppLayout>
    ),
  },
];
